import React, { useId } from 'react';
import { INPUT, SUB_LABEL } from './styles';
import useDebouncedCommit from './useDebouncedCommit';

/** Minimum / maximum (inclusive). Value: { min, max } as strings. */
const NumberRangeRenderer = ({ field, value, onChange }) => {
    const id = useId();
    const [draft, change] = useDebouncedCommit(value || {}, (next) => onChange(next));
    const set = (end, next) => change({ ...draft, [end]: next });
    const input = (end, label) => (
        <div>
            <label htmlFor={`${id}-${end}`} className={SUB_LABEL}>
                {label}
            </label>
            <input
                id={`${id}-${end}`}
                type="number"
                inputMode="numeric"
                min={field.min ?? 0}
                step={field.step ?? 1}
                value={draft[end] ?? ''}
                onChange={(e) => set(end, e.target.value)}
                aria-label={`${field.label} ${label.toLowerCase()}`}
                className={INPUT}
            />
        </div>
    );
    return (
        <div className="grid grid-cols-2 gap-2">
            {input('min', 'Minimum')}
            {input('max', 'Maximum')}
        </div>
    );
};

export default NumberRangeRenderer;
